import React, {Fragment, useEffect, useRef} from "react";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";

import IconButton from "@mui/material/IconButton";
import ReplayIcon from '@mui/icons-material/Replay';
import {setLookRestoreState, updateNavigationCount} from "../../../../../actions/lookFunctions";
import WithZoomToFeature from "../../../hocs/withZoomToFeature";
import LookCanvasContext from "../../../lookCanvasContext";
// import LookFeatureRevertButtonModal from "./lookFeatureRevertButtonModal";
import {getCurrentLayout} from "../../../../appLayout";
import WithUpdateLookCartItem from "../../../hocs/withUpdateLookCartItem";
import {IS_PRODUCT_JOURNEY} from "../../../../../config";


const LookFeatureRevertButton = (props) => {

  const {lookActiveFeature, intl, updateNavigationCount, lookRestoreState, setLookRestoreState, isMobile,
    lookActiveCategory, currentActiveFeature} = props;
  const anchorRef = useRef(null);
  // const [showRevertModal, setShowRevertModal] = useState(false);

  useEffect(() => {
    if (((!isMobile && lookActiveFeature) || (isMobile && lookActiveCategory)) && !lookRestoreState) {
      const layout = getCurrentLayout();
      setLookRestoreState(layout.getActiveFeaturesAsObject(false, false, true));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lookActiveFeature, lookActiveCategory])

  if (!isMobile && !lookActiveFeature) {
    return null
  }

  if (isMobile && !lookActiveCategory) {
    return null
  }

  const layout = getCurrentLayout();
  const featureGroup = lookActiveFeature ? lookActiveFeature.getParent() : layout.getFeatureGroupByPartId(lookActiveCategory);

  if (!featureGroup) {
    return null
  }

  const revertButtonClick = (zoomToFeatureGroup, updateLookCartItem) => {
    if (!lookRestoreState) {
      return false
    }
    const layout = getCurrentLayout();
    layout.setActiveFeaturesFromObject(lookRestoreState);
    if (!isMobile) {
      zoomToFeatureGroup(featureGroup.partId);
      setLookRestoreState(null);
    }
    updateNavigationCount();
    updateLookCartItem(featureGroup.lookActiveFeature, true);
  };

  const disabled = !lookRestoreState
    || !lookRestoreState[featureGroup.partId]
    || (currentActiveFeature && (lookRestoreState[featureGroup.partId] === currentActiveFeature.dbFeature.id))

  return (
    <LookCanvasContext.Consumer>
      {(imageCanvas) => (
        <WithZoomToFeature imageCanvas={imageCanvas}>
          {(zoomToFeatureGroup) => (
            <WithUpdateLookCartItem>
              {(updateLookCartItem) => {

                if (IS_PRODUCT_JOURNEY) {
                  return isMobile ? (
                    <IconButton aria-label={intl.formatMessage({id:"iconButton.back"})}
                                disabled={disabled}
                                className={"gm-footer__menu look-icon look-button look-button--secondary look-button--no-radius"}
                                onClick={() => revertButtonClick(zoomToFeatureGroup, updateLookCartItem)}>
                      <ReplayIcon/>
                    </IconButton>
                  ) : (
                    <div className="grohe-sold">
                      <IconButton aria-label={intl.formatMessage({id:"iconButton.back"})}
                                  ref={anchorRef}
                                  disabled={disabled}
                                  className="look-icon look-icon--small lk-feature__revert"
                                  // onMouseOver={() => setShowRevertModal(true)}
                                  // onMouseLeave={() => setShowRevertModal(false)}
                                  onClick={() => revertButtonClick(zoomToFeatureGroup, updateLookCartItem)}>
                        <ReplayIcon/>
                      </IconButton>
                      <span className="grohe-sold__text"></span>
                    </div>
                  )
                }

                return (
                  <Fragment>
                    <IconButton aria-label={intl.formatMessage({id:"iconButton.back"})}
                                ref={anchorRef}
                                disabled={disabled}
                                className="look-icon look-icon--small lk-feature__revert"
                                // onMouseOver={() => setShowRevertModal(true)}
                                // onMouseLeave={() => setShowRevertModal(false)}
                                onClick={() => revertButtonClick(zoomToFeatureGroup, updateLookCartItem)}>
                      <ReplayIcon/>
                    </IconButton>
                    {/*{isMobile ? null : (*/}
                    {/*  <LookFeatureRevertButtonModal anchorEl={anchorRef}*/}
                    {/*                                lookFeature={lookActiveFeature}*/}
                    {/*                                showRevertModal={showRevertModal}*/}
                    {/*                                setShowRevertModal={setShowRevertModal} />*/}
                    {/*)}*/}
                  </Fragment>
                )
              }}
            </WithUpdateLookCartItem>
          )}
        </WithZoomToFeature>
      )}
    </LookCanvasContext.Consumer>
  )
};

LookFeatureRevertButton.propTypes = {
  // lookFeature: PropTypes.shape(featureInterface),
}

const mapStateToProps = (store) => {
  const {lookActiveFeature, lookRestoreState, lookActiveCategory} = store.lookState;
  const {isMobile} = store.serverState;

  let currentActiveFeature = lookActiveFeature;
  if (isMobile && lookActiveCategory) {
    const layout = getCurrentLayout();
    const featureGroup = layout.getFeatureGroupByPartId(lookActiveCategory);
    currentActiveFeature = featureGroup ? featureGroup.activeFeature : null;
  }

  return {
    lookActiveCategory,
    lookActiveFeature,
    lookRestoreState,
    isMobile,
    currentActiveFeature,
  };
};

const mapDispatchToProps = {
  updateNavigationCount,
  setLookRestoreState,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookFeatureRevertButton)
)
